'use client';

import Link from 'next/link';

import { Menu } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@kit/ui/dropdown-menu';
import { NavigationMenu, NavigationMenuList } from '@kit/ui/navigation-menu';
import { Trans } from '@kit/ui/trans';

import { useSession } from '../_hooks/use-session';
import { SiteNavigationItem } from './site-navigation-item';

const authenticatedLinks: Array<{ label: string; path: string }> = [
  {
    label: 'marketing:changelog',
    path: '/changelog',
  },
  {
    label: 'marketing:documentation',
    path: '/docs',
  },
];

export function SiteNavigation() {
  const session = useSession();

  if (!session.data) {
    return null;
  }

  return (
    <>
      <div
        className={'hidden items-center justify-center md:flex'}
        data-testid="site-navigation-desktop"
      >
        <NavigationMenu>
          <NavigationMenuList className={'gap-x-2.5'}>
            {authenticatedLinks.map((item) => (
              <SiteNavigationItem key={item.path} path={item.path}>
                <Trans i18nKey={item.label} />
              </SiteNavigationItem>
            ))}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      <div className={'flex justify-start sm:items-center md:hidden'}>
        <MobileDropdown />
      </div>
    </>
  );
}

function MobileDropdown() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={'Menu'}
        data-testid="site-navigation-mobile-trigger"
      >
        <Menu className={'h-8 w-8'} />
      </DropdownMenuTrigger>

      <DropdownMenuContent className={'w-full'}>
        {authenticatedLinks.map((item) => (
          <DropdownMenuItem key={item.path} asChild>
            <Link className="flex h-full w-full items-center" href={item.path}>
              <Trans i18nKey={item.label} />
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
